import Swal from 'sweetalert2/dist/sweetalert2.js';

/*Tps-report*/
if (window.location.pathname.includes('alert') && !window.location.pathname.includes('admin/alerts')) {
    // Date range picker
    let range_start_date = $('#startDatePicker').val();
    let range_end_date = $('#endDatePicker').val();

    $('.alert-datepicker').datepicker({
        uiLibrary: 'bootstrap4',
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
    });

    $('#startDatePicker').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        maxDate: function () {
            return $('#endDatePicker').val();
        },
        open: function () {
            $('#startDatePicker').closest('.form-daterangepicker').addClass('active');
        },
        close: function () {
            $('#startDatePicker').closest('.form-daterangepicker').removeClass('active');
        },
        change: function (e) {
            if (range_start_date !== e.currentTarget.value) {
                range_start_date = e.currentTarget.value;
                window.app_methods.getAlerts({
                    start_date: range_start_date,
                    end_date: range_end_date
                });
            }
        }
    });

    $('#endDatePicker').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        minDate: function () {
            return $('#startDatePicker').val();
        },
        open: function () {
            $('#endDatePicker').closest('.form-daterangepicker').addClass('active');
        },
        close: function () {
            $('#endDatePicker').closest('.form-daterangepicker').removeClass('active');
        },
        change: function (e) {
            if (range_end_date !== e.currentTarget.value) {
                range_end_date = e.currentTarget.value;
                window.app_methods.getAlerts({
                    start_date: range_start_date,
                    end_date: range_end_date
                });
            }
        }
    });

    $('.form-control-date-custom').on('click', function () {
        $(this).closest('.form-control-wrap').find('input').trigger('focus');
    });

    $(window).on("popup_close", function(e, popover, confirm){
        $(".update-alert").popover("hide");
        $(".complete-alert").popover("hide");
        $(".delete-alert").popover("hide");
    });

    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        var ele = $(popover.element);
        if(confirm && ele.hasClass("complete-alert")) {
            window.app_methods.completeAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("update-alert")) {
            window.app_methods.updateAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("delete-alert")) {
            window.app_methods.deleteAlert();
        }
        ele.popover("dispose");
    });


    /** CRM APPROVALS */
    // Contact Alert
    const contactOptions = {
        order: [[3, 'desc']],
        columnDefs: [
            {
                render: function(data, type, row){
                    return data ? "<a href='/crm/contact/"+row.contact_id+"'>"+data+"</a>" : "Unnamed";
                },
                targets: 'col-name',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 text-left">' + data.map((p) => (p && p.policyholder ? `<li><a href="/placement/edit/${p.id}">${p.policyholder.name}</a></li>` : '<li>-</li>')).join('') + '</ul>' : '-';
                },
                targets: 'col-source',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 text-left">' + data.map((name) => `<li>${name}</li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-changed_by',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 text-left">' + data.map((date) => `<li>${moment(date).local().format('MM/DD/YYYY hh:mm:ss A')}</li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-updated_at',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return `<button class="btn btn-secondary pending-approve" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}">Approve</button>
                        <button type="button" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" class="btn btn-danger pending-reject ml-1">Reject</button>`;
                },
                targets: 'col-commands',
                width: "170px",
            },
        ]
    };

    $('.data-table.contact-table').data('options', contactOptions).on('click', '.pending-approve', function () {
        const requestable_id = $(this).data('requestable_id');
        const requestable_type = $(this).data('requestable_type');
        const row = $(this).closest("tr");

        openApproveModal(requestable_id, requestable_type, row, '/api/contact/dismiss', 'updateRequestContact', 'contact', 'contactApprovalForm');
    });

    $('.data-table.contact-table').on('click', '.btn-dismiss, .pending-reject', function () {
        const requestable_id = $(this).data('requestable_id');
        const row = $(this).closest("tr");
        openRejectModal(requestable_id, row, '/api/contact/dismiss', 'updateRequestContact', 'contact', 'rejected');
    });

    // Hotel Alert
    const hotelOptions = {
        order: [[3, 'desc']],
        columnDefs: [
            {
                render: function(data, type, row){
                    return data ? "<a href='/crm/hotel/"+row.hotel_id+"'>"+data+"</a>" : "No Name";
                },
                targets: 'col-name',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 pl-4 text-left">' + data.map((p) => (p && p.policyholder ? `<li><a href="/placement/edit/${p.id}">${p.policyholder.name}</a></li>` : '<li>-</li>')).join('') + '</ul>' : '-';
                },
                targets: 'col-source',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 pl-4 text-left">' + data.map((name) => `<li>${name}</li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-changed_by',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 pl-4 text-left">' + data.map((date) => `<li>${moment(date).local().format('MM/DD/YYYY hh:mm:ss A')}</li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-updated_at',
                width: "200px",
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 pl-4 text-left">' + JSON.parse(data).map((h) => `<li><button class="btn btn-link hotel-match" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" data-type="name" data-hotel_id="${h.id}">${h.name}</button></li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-name_matches',
            },
            {
                render: function (data, type, row) {
                    return data ? '<ul class="m-0 pl-4 text-left">' + JSON.parse(data).map((h) => `<li><button class="btn btn-link hotel-match" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" data-type="address" data-hotel_id="${h.id}">${h.address}</button></li>`).join('') + '</ul>' : '-';
                },
                targets: 'col-address_matches',
            },
            {
                render: function (data, type, row) {
                    return `<button class="btn btn-secondary pending-approve" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}">Approve</button>
                        <button type="button" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" class="btn btn-danger pending-reject ml-1">Reject</button>`;
                },
                targets: 'col-commands',
                width: "170px",
            },
        ]
    };

    $('.data-table.hotel-table').data('options', hotelOptions).on('click', '.hotel-match', function () {
        const id = $(this).data('hotel_id');
        const type = $(this).data('type');
        const requestable_id = $(this).data('requestable_id');
        const requestable_type = $(this).data('requestable_type');
        const row = $(this).closest("tr");

        Swal.fire({
            title: `Hotel ${type} match`,
            html: `<div id="matchModal">
                <v-hotel-approval :data="data" :update_requests="update_requests" :options="options" :readonly="true"></v-hotel-approval>
            </div>`,
            icon: undefined,
            showCancelButton: true,
            confirmButtonText: "Use existing data",
            showLoaderOnConfirm: true,
            reverseButtons: true,
            width: 1024,
            heightAuto: false,
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !!Swal.isLoading(),
            allowEnterKey: () => !Swal.isLoading(),
            onRender: () => {
                Swal.showLoading();
                window.hotelMatchResponse = null;

                $.ajax({
                    url: "/api/hotel/get",
                    method: 'POST',
                    data: { id },
                    success: function(response) {
                        window.hotelMatchResponse = response;
                        new Vue({
                            el: `#matchModal`,
                            data: {
                                data: response,
                                update_requests: [],
                                options: window.app_options,
                            },
                        });

                        Swal.hideLoading();
                    },
                    error: function(error) {
                        Swal.hideLoading();
                        Swal.showValidationMessage(`Error getting data!`);
                        console.error('Error getting data:', error);
                    }
                });
            },
        }).then((result) => {
            if (result.isConfirmed) {
                openApproveModal(requestable_id, requestable_type, row, '/api/hotel/dismiss', 'updateRequestHotel', 'hotel', 'hotelApprovalForm', window.hotelMatchResponse);
            }
        });
    });

    $('.data-table.hotel-table').data('options', hotelOptions).on('click', '.pending-approve', function () {
        const requestable_id = $(this).data('requestable_id');
        const requestable_type = $(this).data('requestable_type');
        const row = $(this).closest("tr");

        openApproveModal(requestable_id, requestable_type, row, '/api/hotel/dismiss', 'updateRequestHotel', 'hotel', 'hotelApprovalForm');
    });

    $('.data-table.hotel-table').on('click', '.btn-dismiss, .pending-reject', function () {
        const requestable_id = $(this).data('requestable_id');
        const row = $(this).closest("tr");
        openRejectModal(requestable_id, row, '/api/hotel/dismiss', 'updateRequestHotel', 'hotel', 'rejected');
    });

    function flattenErrors(errors) {
        errors = Object.values(errors)
        errors = errors.flat()

        return errors;
    }

    function openApproveModal(requestable_id, requestable_type, row, url, table_id, type, form_id, match_response) {
        Swal.fire({
            title: `Pending ${type} approval`,
            html: `<div id="approvalModal">
                <v-contact-approval v-if="type === 'contact'" :data="data" :update_requests="update_requests" :options="options"></v-contact-approval>
                <v-hotel-approval v-if="type === 'hotel'" :hotel_id="hotel_id" :data="data" :update_requests="update_requests" :options="options"></v-hotel-approval>
            </div>`,
            icon: undefined,
            showCancelButton: true,
            confirmButtonText: "Approve",
            showDenyButton: true,
            denyButtonText: "Reject",
            denyButtonColor: '#ff1d25',
            showLoaderOnConfirm: true,
            reverseButtons: true,
            width: 1024,
            heightAuto: false,
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !!Swal.isLoading(),
            allowEnterKey: () => !Swal.isLoading(),
            preConfirm: async () => {
                try {
                    const result = await new Promise((resolve, reject) => {
                        const form = $(`#${form_id}`);
                        const data = form.serializeArray().reduce((obj, { name, value }) => {
                            name.split('[').reduce((acc, key, i, arr) => {
                                key = key.replace(']', '');
                                if (i === arr.length - 1) acc[key] = value;
                                else acc[key] = acc[key] || {};
                                return acc[key];
                            }, obj);
                            return obj;
                        }, {});

                        $.ajax({
                            url: form.attr('action'),
                            method: "POST",
                            data: { ...data, requestable_id },
                            dataType: "json",
                            success: response => resolve(response),
                            error: response => reject(response)
                        });
                    });

                    return result;
                } catch (e) {
                    if (e.responseJSON && e.responseJSON.errors) {
                        message("<ul class='pl-4'><li>" + flattenErrors(e.responseJSON.errors).join("</li><li>") + "</li></ul>", 1);
                    }
                    Swal.showValidationMessage(`There is something wrong!`);
                }
            },
            onRender: () => {
                Swal.showLoading();

                $.ajax({
                    url: "/api/update_request",
                    method: 'POST',
                    data: { requestable_id, requestable_type },
                    success: function(response) {
                        new Vue({
                            el: `#approvalModal`,
                            data: {
                                type,
                                hotel_id: match_response ? match_response.id : null,
                                data: match_response ? match_response : response.master_data,
                                update_requests: response.update_requests,
                                options: window.app_options,
                            },
                        });

                        Swal.hideLoading();
                    },
                    error: function(error) {
                        Swal.hideLoading();
                        Swal.showValidationMessage(`Error getting data!`);
                        console.error('Error getting data:', error);
                    }
                });
            },
        }).then((result) => {
            if (result.isConfirmed) {
                removePendingRow(row, table_id, type, 'approved');
            } else if (result.isDenied) {
                openRejectModal(requestable_id, row, url, table_id, type, 'rejected');
            }
        });
    }

    function openRejectModal(requestable_id, row, url, table_id, type, action = 'approved') {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff1d25',
            confirmButtonText: 'Reject',
            reverseButtons: true,
            heightAuto: false,
        }).then(result => {
            if (result.isConfirmed) {
                $.ajax({
                    url,
                    method: "post",
                    data: { requestable_id },
                    dataType: 'json',
                    success: () => removePendingRow(row, table_id, type, action),
                });
            }
        });
    }

    function removePendingRow(row, table_id, type, action = 'approved') {
        if (row.hasClass("child")) row = row.prev();
        $(`[data-id="${table_id}"]`).DataTable().row(row[0]).remove().draw();
        Swal.fire({
            title: action.charAt(0).toUpperCase() + action.slice(1),
            text: `The pending ${type} has been ${action}.`,
            heightAuto: false,
            icon: 'success'
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/alert.js